/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useCart } from 'hooks/token/useCart'
import { getlistProductsPixel } from './servicePixel'
import { useMockRespPixel } from 'pages/Credito/1-Consulta/ModulosConsulta/mocks'


export function usePixel(props){
    const {
        section = ""
    } = props

    // const { pixelProducts, setPixelProducts } = useMockRespPixel()
    const [pixelProducts, setPixelProducts] = useState()

    const [productsDesktop, setProductsDesktop] = useState(null)
    const [productsMovil, setProductsMovil] = useState(null)
    const [firstProdMovil, setFirstProdMovil] = useState(null)
    const [productsCount, setProductsCount] = useState(null)
    const [productsP, setProductsP] = useState()
    const [showPixel, setShowPixel] = useState(false)
    const [sendCart, setSendCart] = useState()
    const [pixelInit, setPixelInit] = useState(false)
    
    const { 
        okAdd,
        Product_Add
    } = useCart({firstActive: false, name: "history Pixel", timeRef: 1000})
    
    const history = useHistory();
    
    // Manda la peticion al servicio del pixel
    useEffect(()=>{
        if(section){
            if(pixelInit){
                getlistProductsPixel({ section: section })
                .then(setPixelProducts)
                setPixelInit(false)
            }
        }
    },[section, pixelInit])

    // Hace el recorrido cuando tiene un 200 del servicio
    useEffect(() => {
        if (pixelProducts) {
            if (pixelProducts?.statusCode >= 200 && pixelProducts?.statusCode <= 299) {
                if (typeof (pixelProducts?.data) === 'object') {
                    if (pixelProducts?.data) {
                        if (pixelProducts?.data?.data) {
                            if(pixelProducts?.data?.data[0]?.products){
                                setProductsP({
                                    'products': pixelProducts?.data?.data[0]?.products,
                                    'total_items': pixelProducts?.data?.data[0]?.products.length
                                })
                            }else{
                                setProductsP({
                                    'products': pixelProducts?.data?.data,
                                    'total_items': pixelProducts?.data?.data.length
                                })
                            }
                        }
                    }
                }
                else {
                    setProductsP({});
                }
            }
            else if (pixelProducts?.statusCode !== undefined) {
                setProductsP({});              
            }
        }
    }, [pixelProducts])

    // regresa las respuestas del hook
    useEffect(()=>{
        if(productsP?.products){
            if(productsP?.products?.length >= 1 ){
                let totalProduct = productsP?.products.filter((prod, index) =>  index <= 9 )
                setProductsDesktop(totalProduct)
                let totalProductM = totalProduct.filter((prod, index) => index >= 1 && index <= 9 )
                setProductsMovil(totalProductM)
                let firstProductM = totalProduct.filter((prod, index) => index === 0)
                setFirstProdMovil(firstProductM)
                setProductsCount(productsP?.total_items)
                setShowPixel(true)
            }
        }
    },[productsP])

    //Manda agregar al carrito
    useEffect(()=>{
        if(sendCart){
            Product_Add(sendCart)
        }
    },[sendCart])

    useEffect(()=>{
        if(okAdd){
            history.push('/carrito/detalle');
        }
    },[okAdd])


    // Recibe peticion para agregar a carrito
    const addCartProduct = (val) => {
        let productID = val
        let setCart = [{ "id_product": productID, "children_sku": 0, "quantity": 1 }];
        // console.log('setCart: ', setCart)
        setSendCart(setCart)
    }

    const initPixel = (val) => {
        setPixelInit(val)
    }

    return {
        initPixel,
        productsDesktop,
        productsMovil,
        productsCount,
        firstProdMovil,
        showPixel,
        addCartProduct
    }
}